import { toast } from "react-toastify";
import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getCardioActivitiesAction,
  getFacilitySettingsAction,
  getSelectedCardioActivitiesAction,
  saveCardioActivitiesAction,
  saveFacilitySettingsAction,
} from "./facilityOptionsActions";
import * as facilityOptionsServices from "./facilityOptionsServices";
import {
  setCardioActivities,
  setCardioActivityCheckedOrUnchecked,
  setFacilitySettings,
  setLoading,
  setSelectedCardioActivities,
} from "./facilityOptionsSlice";

function* getFacilitySettingsSaga() {
  try {
    yield put(setLoading(true));
    const res = yield call(facilityOptionsServices.getFacilitySettings);
    yield put(setFacilitySettings({ ...res }));
  } catch (error) {
    // yield put(setFacilitySettings({ error }));
  }
  yield put(setLoading(false));
}

function* saveFacilitySettingsSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const res = yield call(facilityOptionsServices.saveFacilitySettings, payload);
    toast.success("Settings updated.");
    yield put(getFacilitySettingsAction());
  } catch (error) {
    toast.error(error.message);
  }
  yield put(setLoading(false));
}

function* getSelectedCardioActivitiesSaga() {
  try {
    yield put(setLoading(true));
    const res = yield call(facilityOptionsServices.getCardioActivities, {
      is_checked: true,
      limit: 50,
      sort_by: "TITLE",
      sort_order: "ASC",
    });
    const localRes = { ...res };
    yield put(setSelectedCardioActivities(localRes));
  } catch (error) {}
  yield put(setLoading(false));
}

function* getCardioActivitiesSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const res = yield call(facilityOptionsServices.getCardioActivities, payload);
    yield put(setCardioActivities({ ...res }));
  } catch (error) {}
  yield put(setLoading(false));
}

function* saveCardioActivitiesSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const res = yield call(facilityOptionsServices.saveCardioActivities, {
      ltblcardioactivityincludes: [payload],
    });
    toast.success("Cardio activities updated.");
    yield put(setCardioActivityCheckedOrUnchecked(payload));
    yield put(getSelectedCardioActivitiesAction());
  } catch (error) {
    toast.error(error.message);
  }
  yield put(setLoading(false));
}

function* watchGetFacilitySettingsSaga() {
  yield takeLatest(getFacilitySettingsAction, getFacilitySettingsSaga);
}

function* watchSaveFacilitySettingsSaga() {
  yield takeLatest(saveFacilitySettingsAction, saveFacilitySettingsSaga);
}

function* watchGetSelectedCardioActivitiesSaga() {
  yield takeLatest(getSelectedCardioActivitiesAction, getSelectedCardioActivitiesSaga);
}

function* watchGetCardioActivitiesSaga() {
  yield takeLatest(getCardioActivitiesAction, getCardioActivitiesSaga);
}

function* watchSaveCardioActivitiesSaga() {
  yield takeLatest(saveCardioActivitiesAction, saveCardioActivitiesSaga);
}

export default function* () {
  yield all([
    watchGetCardioActivitiesSaga(),
    watchGetFacilitySettingsSaga(),
    watchGetSelectedCardioActivitiesSaga(),
    watchSaveCardioActivitiesSaga(),
    watchSaveFacilitySettingsSaga(),
  ]);
}
